var klarnaCreditPromotion = {

    elements: {},

    init: function() {
        if(typeof BoosterTheme == 'undefined') {
            return;
        }

        if(typeof KlarnaOnsiteService == 'undefined') {
            return;
        }

        if(!this.getElements()) {
            return;
        }

        this.setEvents();
    },

    getElements: function() {
        this.elements.placement = jQuery('.klarna-credit-promotion > klarna-placement');
        if(!this.elements.placement.length) {
            return false;
        }

        return true;
    },

    setEvents: function() {
        var _self = this;

        BoosterTheme.swatches.THEME_UTILS.events.on('booster:variant:select', function(arguments) {
            if(typeof arguments.selectedVariant == 'undefined') {
                return;
            }

            if(typeof arguments.selectedVariant.price_raw == 'undefined') {
                return;
            }

            _self.updatePlacementPrice(arguments.selectedVariant.price_raw);
        });
    },

    updatePlacementPrice: function(price) {
        this.elements.placement.attr('data-purchase-amount', price);
        KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    }

};

function initKlarnaCreditPromotion() {
    if(typeof BoosterTheme == 'undefined') {
      setTimeout(initKlarnaCreditPromotion, 200);
  
      return;
    }
  
    klarnaCreditPromotion.init();
  }
  
  jQuery(document).ready(function() {
    initKlarnaCreditPromotion();
  });